import type { Work } from "@/types/content";

export const works: Work[] = [
  {
    id: "m1",
    title: "暗夜追光",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-01-16",
    duration: "128分钟",
    rating: 8.4,
    heat: 9820,
    director: "陈亦然",
    cast: [
      { name: "林峯", role: "周野（刑警）", bio: "从警十二年的重案组刑警，因一桩旧案与过去正面重逢。" },
      { name: "沈知夏", role: "苏婉（记者）", bio: "执着于真相的调查记者，这场追捕里最清醒的那个人。" },
      { name: "高铭", role: "陆行（法医）", bio: "沉默寡言的法医，用一把解剖刀拼出被抹去的证词。" },
    ],
    synopsis:
      "一场突如其来的连环失踪案，将刑警周野拖回十二年前那宗没能结案的旧案。城市在雨夜里露出一条又一条被刻意隐藏的线索，而每条线索的尽头，都指向他曾经最信任的搭档。当真相越来越近，周野必须在正义与情义之间，做出一个无法回头的选择。",
    tagline: "有些黑暗，只能用光去追。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20rainy%20city%20street%20at%20night%2C%20lone%20detective%20silhouette%2C%20teal%20and%20amber%20neon%20reflections%2C%20moody%20crime%20thriller%20movie%20poster%2C%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=cover-m1&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=neon%20rain-soaked%20metropolis%20at%20night%2C%20cinematic%20wide%20shot%2C%20teal%20and%20amber%20light%20reflections%20on%20wet%20streets%2C%20dramatic%20thriller%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-1&orientation=landscape",
    tags: ["年度悬疑", "雨夜追凶", "双男主演技"],
  },
  {
    id: "m2",
    title: "云端之上",
    type: "movie",
    genres: ["科幻", "剧情"],
    region: "美国",
    year: 2025,
    releaseDate: "2025-11-07",
    duration: "142分钟",
    rating: 8.1,
    heat: 8610,
    director: "Ava Sinclair",
    cast: [
      { name: "伊桑·科尔", role: "诺亚（气候工程师）", bio: "建造空中避难城的工程师，却在最后关头开始质疑这一切。" },
      { name: "玛戈·里德", role: "莉娜（城市管理者）", bio: "在秩序与人性之间艰难维持平衡的云城掌舵者。" },
      { name: "韩叙", role: "陆晨（气象学家）", bio: "第一个发现云层异常的人，也是第一个被质疑的人。" },
    ],
    synopsis:
      "当地面已不再适合生存，人类把城市建在了云端。气候工程师诺亚本以为这是文明的延续，直到他发现支撑云城的能量系统正在以地面世界为代价运转。他必须在维持数百万人栖身的城市与揭露真相之间，找到第三种答案。",
    tagline: "我们住进了天空，却把根留在了废墟。",
    cover:
      "https://readdy.ai/api/search-image?query=floating%20cloud%20city%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20futuristic%20architecture%2C%20soft%20warm%20golden%20light%2C%20epic%20sci-fi%20movie%20poster%2C%20cinematic%2C%20no%20text&width=600&height=900&seq=cover-m2&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=vast%20cosmic%20nebula%20with%20a%20lone%20spaceship%20silhouette%2C%20epic%20sci-fi%20wide%20cinematic%20shot%2C%20deep%20space%20colors%2C%20no%20text&width=1600&height=900&seq=hero-2&orientation=landscape",
    tags: ["科幻新浪潮", "环保命题", "视觉盛宴"],
  },
  {
    id: "m3",
    title: "潮汐之城",
    type: "movie",
    genres: ["剧情", "爱情"],
    region: "日本",
    year: 2025,
    releaseDate: "2025-08-22",
    duration: "116分钟",
    rating: 7.9,
    heat: 6420,
    director: "小林透",
    cast: [
      { name: "佐藤绫", role: "潮见遥", bio: "回到故乡小镇的钢琴教师，带着一个没说出口的告别。" },
      { name: "山田悠真", role: "仓桥光", bio: "守着旧书店的青年，相信有些约定会像潮水一样回来。" },
      { name: "田中真纪", role: "潮见绫乃", bio: "遥的母亲，小镇上最会等待的人。" },
    ],
    synopsis:
      "离开小镇十年后，钢琴教师遥回到了这座被潮水环绕的滨海城市。旧书店、老站台、涨落之间的海岸线，一切都停在离别的那年夏天。她本想处理完母亲的旧宅就离开，却在与守店青年光的重逢里，重新听见了那些被搁置的心事。",
    tagline: "潮水会带走一切，也会送回一些。",
    cover:
      "https://readdy.ai/api/search-image?query=coastal%20seaside%20town%20at%20golden%20sunset%2C%20gentle%20waves%2C%20nostalgic%20romantic%20mood%2C%20warm%20muted%20film%20tones%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-m3&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=majestic%20ancient%20chinese%20palace%20under%20golden%20sunset%2C%20epic%20costume%20drama%20wide%20cinematic%20shot%2C%20warm%20amber%20sky%2C%20no%20text&width=1600&height=900&seq=hero-3&orientation=landscape",
    tags: ["夏日治愈", "错位重逢", "日式美学"],
  },
  {
    id: "m4",
    title: "钢铁黎明",
    type: "movie",
    genres: ["动作", "科幻"],
    region: "美国",
    year: 2026,
    releaseDate: "2026-03-06",
    duration: "135分钟",
    rating: 7.6,
    heat: 8890,
    director: "Marcus Vale",
    cast: [
      { name: "德里克·肖", role: "凯恩（机甲驾驶员）", bio: "被战争磨平棱角的王牌驾驶员，只剩最后一次任务。" },
      { name: "诺拉·布莱克", role: "艾薇（工程师）", bio: "造出这台钢铁巨兽的人，也是唯一能拆掉它的人。" },
      { name: "陈望", role: "韩铮（指挥官）", bio: "在地图前做决定的男人，代价永远由别人承担。" },
    ],
    synopsis:
      "人类最后的防线只剩下一台还能启动的巨型机甲，和一位再也不想上战场的驾驶员。当敌方军团逼近城下，凯恩必须驾驶这台被时代抛弃的钢铁巨兽，在黎明到来之前，为身后的城市争取最后一次喘息。",
    tagline: "钢铁会生锈，信念不会。",
    cover:
      "https://readdy.ai/api/search-image?query=giant%20steel%20robot%20silhouette%20in%20a%20burning%20futuristic%20battlefield%2C%20orange%20sparks%20and%20smoke%2C%20dramatic%20action%20sci-fi%20movie%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-m4&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=futuristic%20burning%20battlefield%20with%20giant%20mecha%20silhouette%2C%20orange%20embers%20and%20smoke%2C%20epic%20action%20sci-fi%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-4&orientation=landscape",
    tags: ["硬核机甲", "视效大片", "末日战场"],
  },
  {
    id: "m5",
    title: "长街旧梦",
    type: "movie",
    genres: ["剧情"],
    region: "中国大陆",
    year: 2024,
    releaseDate: "2024-10-01",
    duration: "121分钟",
    rating: 8.7,
    heat: 7130,
    director: "苏文清",
    cast: [
      { name: "梁启明", role: "老周（修表匠）", bio: "守着一间修表铺四十年的老人，时间在他手里走得很慢。" },
      { name: "何雨彤", role: "周念", bio: "离乡多年后回来的女儿，想找回的不是房子，是家。" },
      { name: "王建国", role: "老邻居 李叔", bio: "长街上最后一个还没搬走的老街坊。" },
    ],
    synopsis:
      "一条即将拆迁的老街，一间开了四十年的修表铺，一位不愿离开的修表匠。当多年前离家的女儿回到长街，父女俩在拆迁倒计时里重新学着说话。那些被时间收走的日子，随着一只停摆的旧表，被一点点拨回了正轨。",
    tagline: "时间修得好，人心也一样。",
    cover:
      "https://readdy.ai/api/search-image?query=old%20narrow%20alleyway%20of%20a%20southern%20chinese%20town%20in%20the%201990s%2C%20warm%20nostalgic%20afternoon%20light%2C%20cinematic%20realism%20movie%20poster%2C%20no%20text&width=600&height=900&seq=cover-m5&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20old%20chinese%20street%20alleyway%20at%20dusk%2C%20soft%20afternoon%20light%2C%20cinematic%20realism%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-5&orientation=landscape",
    tags: ["华语现实主义", "家庭", "口碑佳作"],
  },
  {
    id: "m6",
    title: "星际信使",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "英国",
    year: 2026,
    releaseDate: "2026-02-13",
    duration: "148分钟",
    rating: 8.3,
    heat: 9020,
    director: "Oliver Grant",
    cast: [
      { name: "亚瑟·凯恩", role: "艾略特（宇航员）", bio: "独自航行的信使，带着全人类唯一的回信。" },
      { name: "佐伊·哈特", role: "薇拉（地面指挥）", bio: "在延迟几十年的通讯里，等待一个声音的人。" },
      { name: "周砚", role: "顾远（任务设计师）", bio: "设计这次单程航行的人，从未告诉任何人真相。" },
    ],
    synopsis:
      "人类第一次收到了来自深空的回信。为了完成这场跨越光年的对话，宇航员艾略特独自踏上单程航行。随着距离越来越远，信号延迟从分钟变成数年，他必须在地面世界早已改变的情况下，把一个答案送回地球。",
    tagline: "最遥远的距离，是等一句回音。",
    cover:
      "https://readdy.ai/api/search-image?query=lone%20astronaut%20beside%20a%20vast%20glowing%20nebula%2C%20deep%20space%2C%20dramatic%20cosmic%20light%2C%20cinematic%20sci-fi%20movie%20poster%2C%20no%20text&width=600&height=900&seq=cover-m6&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=astronaut%20floating%20before%20a%20colossal%20glowing%20nebula%2C%20deep%20space%20epic%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-6&orientation=landscape",
    tags: ["硬科幻", "孤独浪漫", "IMAX 视效"],
  },
  {
    id: "m7",
    title: "无声证词",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "韩国",
    year: 2025,
    releaseDate: "2025-09-19",
    duration: "124分钟",
    rating: 8.0,
    heat: 7350,
    director: "朴正勋",
    cast: [
      { name: "李在勋", role: "韩东洙（检察官）", bio: "在证据链里寻找裂缝的检察官，从不相信巧合。" },
      { name: "金素妍", role: "尹美娜（辩护律师）", bio: "为沉默者辩护，却发现自己也站在被告席上。" },
      { name: "崔民浩", role: "张赫（目击者）", bio: "唯一看见真相的人，也是唯一不敢开口的人。" },
    ],
    synopsis:
      "一桩没有目击者、没有凶器、没有动机的命案，唯一的证物是一段被消音的录音。检察官韩东洙与辩护律师尹美娜在法庭内外反复交锋，直到他们发现，真正被隐藏的证词，来自一个再也无法开口的人。",
    tagline: "最重的证词，往往是最安静的。",
    cover:
      "https://readdy.ai/api/search-image?query=cold%20interrogation%20room%20with%20a%20single%20hanging%20light%2C%20tense%20noir%20atmosphere%2C%20muted%20blue%20grey%20tones%2C%20korean%20crime%20thriller%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-m7&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=cold%20noir%20interrogation%20room%20with%20a%20single%20hanging%20light%20and%20empty%20chair%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-7&orientation=landscape",
    tags: ["法庭悬疑", "高能反转", "韩式犯罪"],
  },
  {
    id: "m8",
    title: "山与海之间",
    type: "movie",
    genres: ["剧情"],
    region: "中国台湾",
    year: 2025,
    releaseDate: "2025-06-27",
    duration: "130分钟",
    rating: 8.5,
    heat: 5980,
    director: "黄立川",
    cast: [
      { name: "陈柏言", role: "阿海（登山向导）", bio: "把山当作归宿的人，却在海边学会了告别。" },
      { name: "吴雨晴", role: "小岚（摄影师）", bio: "用镜头寻找父亲背影的女孩。" },
      { name: "林国栋", role: "老陈（渔民）", bio: "一辈子没离开过这片海的人。" },
    ],
    synopsis:
      "一名登山向导，一位来拍父亲最后一张照片的摄影师。两人从山脚走到海边，沿途遇见的每个陌生人，都替他们把那些说不出口的话说了出来。这是一趟关于失去与和解的旅程，也是一个人重新学会呼吸的过程。",
    tagline: "走进山里，是为了走到海边。",
    cover:
      "https://readdy.ai/api/search-image?query=misty%20mountain%20ridge%20meeting%20the%20ocean%20at%20dawn%2C%20minimal%20poetic%20landscape%2C%20soft%20pastel%20tones%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-m8&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=misty%20mountain%20ridge%20meeting%20the%20ocean%20at%20dawn%2C%20minimal%20poetic%20landscape%2C%20soft%20pastel%20tones%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-8&orientation=landscape",
    tags: ["疗愈系", "公路电影", "台湾小镇"],
  },
  {
    id: "s1",
    title: "迷雾之城",
    type: "series",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-01-10",
    duration: "全 24 集",
    rating: 8.6,
    heat: 9410,
    director: "郑远东",
    cast: [
      { name: "许安然", role: "沈默（刑侦队长）", bio: "一座城，一个人，一场没有尽头的雾。" },
      { name: "赵启航", role: "顾一鸣（法证）", bio: "相信证据会说真话的技术骨干。" },
      { name: "白露", role: "叶筝（记者）", bio: "第一个说这座城市有问题的人。" },
    ],
    synopsis:
      "一座终年被浓雾笼罩的工业城市，连续发生多起手法一致的案件。刑侦队长沈默在追查中发现，每一条线索都指向十五年前那家早已关停的工厂。雾会散，但有些秘密，越靠近越看不清。",
    tagline: "雾散之后，才看得见城。",
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20modern%20city%20skyline%20at%20night%2C%20mysterious%20mood%2C%20amber%20street%20lamps%2C%20crime%20drama%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s1&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=foggy%20industrial%20city%20skyline%20at%20night%20with%20amber%20street%20lamps%2C%20mysterious%20crime%20drama%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s1&orientation=landscape",
    tags: ["年度剧王", "悬疑天花板", "群像叙事"],
  },
  {
    id: "s2",
    title: "权力之巅",
    type: "series",
    genres: ["剧情", "政治"],
    region: "美国",
    year: 2025,
    releaseDate: "2025-09-05",
    duration: "全 10 集",
    rating: 8.9,
    heat: 8760,
    director: "Daniel Frost",
    cast: [
      { name: "理查德·海耶斯", role: "沃伦（参议员）", bio: "把野心藏进礼貌里的人。" },
      { name: "艾米莉亚·伍德", role: "凯特（幕僚长）", bio: "知道所有人秘密的那个人。" },
      { name: "陆铭", role: "方远（对手）", bio: "曾经的朋友，现在最危险的敌人。" },
    ],
    synopsis:
      "一场看似悬念不大的选举，把三位政坛老手拖进了同一张牌桌。每一步退让都是算计，每一次握手都藏着刀。当权力来到顶点，他们才发现，站得越高，能信任的人越少。",
    tagline: "登上顶峰，然后独自一人。",
    cover:
      "https://readdy.ai/api/search-image?query=grand%20marble%20government%20hall%20interior%2C%20dramatic%20shafts%20of%20light%2C%20powerful%20political%20drama%20mood%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s2&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=grand%20marble%20government%20hall%20interior%20with%20dramatic%20light%20shafts%2C%20political%20drama%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s2&orientation=landscape",
    tags: ["政治神剧", "演技炸裂", "高密度台词"],
  },
  {
    id: "s3",
    title: "时光代理人",
    type: "series",
    genres: ["科幻", "悬疑"],
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-07-18",
    duration: "全 16 集",
    rating: 8.2,
    heat: 8020,
    director: "周牧",
    cast: [
      { name: "顾南舟", role: "程野（代理人）", bio: "能替人回到过去办事的人，却改不了自己的过去。" },
      { name: "温言", role: "林小鱼（搭档）", bio: "负责收拾时间线烂摊子的搭档。" },
      { name: "孙致", role: "老K（委托人）", bio: "每单委托背后，都有一段不能说的往事。" },
    ],
    synopsis:
      "在这座城市里，有一家只接受特殊委托的机构——替人回到过去，完成未了的心愿。代理人程野靠着这份工作糊口，直到接到一单委托，目的地是他自己最想回去、也最不敢回去的那一天。",
    tagline: "能回溯时间的人，最先学会的是放手。",
    cover:
      "https://readdy.ai/api/search-image?query=surreal%20split%20of%20a%20city%20street%20across%20two%20timelines%2C%20glowing%20clock%2C%20sci-fi%20mystery%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s3&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=surreal%20split%20view%20of%20a%20city%20street%20across%20two%20timelines%20with%20a%20glowing%20clock%2C%20sci-fi%20mystery%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s3&orientation=landscape",
    tags: ["高概念", "单元剧", "反转不断"],
  },
  {
    id: "s4",
    title: "锦绣长歌",
    type: "series",
    genres: ["古装", "爱情"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-02-24",
    duration: "全 40 集",
    rating: 7.8,
    heat: 9680,
    director: "沈如玉",
    cast: [
      { name: "苏慕白", role: "萧长风（将军）", bio: "一身战功，只为一个回不去的约定。" },
      { name: "柳如烟", role: "宁昭（公主）", bio: "困在深宫里，却想把整座江山握在手里的人。" },
      { name: "江晚", role: "沈知微（女官）", bio: "看透所有人心思，唯独看不清自己。" },
    ],
    synopsis:
      "乱世将起，名门之女宁昭被迫卷入朝堂与边关的双重棋局。她与少年将军萧长风在权谋与深情之间彼此试探，也在家国与私心之间反复抉择。一曲长歌，唱尽了整整一代人的身不由己。",
    tagline: "身不由己，是乱世最贵的情话。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20garden%20in%20spring%20blossoms%2C%20elegant%20silk%20costume%2C%20warm%20golden%20hour%2C%20romantic%20costume%20drama%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s4&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20garden%20in%20spring%20blossoms%20at%20golden%20hour%2C%20romantic%20costume%20drama%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s4&orientation=landscape",
    tags: ["古装大剧", "权谋", "美到窒息"],
  },
  {
    id: "s5",
    title: "深海迷航",
    type: "series",
    genres: ["科幻", "惊悚"],
    region: "英国",
    year: 2026,
    releaseDate: "2026-03-20",
    duration: "全 8 集",
    rating: 8.0,
    heat: 7890,
    director: "Helen Marsh",
    cast: [
      { name: "托马斯·贝尔", role: "莱恩（艇长）", bio: "把船和船员看得比自己重要的老艇长。" },
      { name: "艾玛·斯通菲尔德", role: "罗莎（生物学家）", bio: "第一个听见那种声音的人。" },
      { name: "方睿", role: "程越（工程师）", bio: "负责让这艘船还能浮起来的人。" },
    ],
    synopsis:
      "一艘深海科考潜艇在执行例行任务时，接收到了一段不该存在于这个深度的信号。为查明来源，艇长莱恩决定偏离航线，驶向那片人类从未抵达过的黑暗。越往下走，他们越分不清，是海在看着他们，还是有人在看着他们。",
    tagline: "越深的黑暗，藏着越近的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20dark%20ocean%20with%20a%20submerged%20submarine%20and%20faint%20bioluminescent%20glow%2C%20tense%20sci-fi%20thriller%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s5&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=deep%20dark%20ocean%20with%20a%20submerged%20submarine%20and%20faint%20bioluminescent%20glow%2C%20tense%20sci-fi%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s5&orientation=landscape",
    tags: ["深海恐惧", "密室惊悚", "高能开场"],
  },
  {
    id: "s6",
    title: "医者仁心",
    type: "series",
    genres: ["剧情", "医疗"],
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-05-12",
    duration: "全 36 集",
    rating: 8.4,
    heat: 8320,
    director: "何静之",
    cast: [
      { name: "秦越", role: "江川（外科主任）", bio: "手术台上从不出错的医生，生活里一塌糊涂。" },
      { name: "叶知秋", role: "苏晚（急诊医生）", bio: "把每个病人都当成最后一次抢救的人。" },
      { name: "罗一舟", role: "陈阳（实习医生）", bio: "第一次面对生死时，才真正明白这一行的重量。" },
    ],
    synopsis:
      "一间永远亮着灯的急诊室，一群把别人的生死当成日常的人。外科主任江川与急诊医生苏晚在一次又一次争分夺秒的抢救中，重新理解了「尽力」二字的分量。这里没有奇迹，只有不肯放手的人。",
    tagline: "所谓仁心，不过是多坚持一分钟。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20modern%20hospital%20corridor%20with%20soft%20daylight%2C%20warm%20hopeful%20tone%2C%20medical%20drama%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s6&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=bright%20modern%20hospital%20corridor%20with%20soft%20daylight%2C%20warm%20hopeful%20tone%2C%20medical%20drama%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s6&orientation=landscape",
    tags: ["现实题材", "催泪", "口碑长虹"],
  },
  {
    id: "s7",
    title: "罪案心理师",
    type: "series",
    genres: ["犯罪", "悬疑"],
    region: "韩国",
    year: 2026,
    releaseDate: "2026-04-03",
    duration: "全 12 集",
    rating: 8.1,
    heat: 8150,
    director: "姜民锡",
    cast: [
      { name: "郑宇成", role: "车贤（侧写师）", bio: "能读懂凶手，却读不懂自己。" },
      { name: "宋智雅", role: "韩瑞妍（刑警）", bio: "不信直觉，只信证据的搭档。" },
      { name: "朴振", role: "李宪（前任侧写师）", bio: "二十年前那桩悬案的唯一幸存者。" },
    ],
    synopsis:
      "犯罪心理侧写师车贤接手一系列看似毫无关联的案件，却发现每个凶手的行为模式，都指向二十年前那桩未结悬案。当他越接近真相，就越逼近自己的过去——一个他亲手埋起来的过去。",
    tagline: "读懂凶手的人，往往最像凶手。",
    cover:
      "https://readdy.ai/api/search-image?query=dim%20forensic%20office%20with%20scattered%20case%20files%20and%20a%20profile%20board%2C%20cold%20moody%20light%2C%20crime%20series%20poster%2C%20cinematic%20no%20text&width=600&height=900&seq=cover-s7&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=dim%20forensic%20office%20with%20a%20profile%20board%20covered%20in%20case%20files%2C%20cold%20moody%20light%2C%20crime%20series%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s7&orientation=landscape",
    tags: ["侧写师", "连环案", "韩剧高分"],
  },
  {
    id: "s8",
    title: "银河边缘",
    type: "series",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2026,
    releaseDate: "2026-05-15",
    duration: "全 9 集",
    rating: 8.8,
    heat: 9130,
    director: "Sofia Renn",
    cast: [
      { name: "加布里埃尔·雷", role: "船长 洛克", bio: "带着一支杂牌船员，航向已知宇宙的边界。" },
      { name: "娜奥米·柯林斯", role: "薇拉（领航员）", bio: "能在混沌中找到坐标的人。" },
      { name: "徐奕", role: "沈澈（机械师）", bio: "全船唯一相信总能修好一切的人。" },
    ],
    synopsis:
      "当母星不再回信，一艘满载希望与麻烦的飞船驶向银河的边缘。船长洛克带着一支互不信任的船员，穿越未知星域，寻找人类最后的可能。每一集，都是一次关于勇气与代价的抉择。",
    tagline: "走到宇宙尽头，只为再听一次家园。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20colossal%20ringed%20planet%20seen%20from%20a%20spaceship%20viewport%2C%20deep%20space%20adventure%2C%20cinematic%20sci-fi%20poster%2C%20no%20text&width=600&height=900&seq=cover-s8&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=a%20colossal%20ringed%20planet%20seen%20from%20a%20spaceship%20viewport%2C%20deep%20space%20adventure%20wide%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=hero-s8&orientation=landscape",
    tags: ["太空歌剧", "群像冒险", "神级配乐"],
  },
];